export default "__VITE_ASSET__CktjKpSC__"